import { ProjectDTO } from '../dtos';
import { QuickSearchResult } from '../views';
import { GET_LANE_PATH_STRING } from '../utils';
import { DATE_MDY } from '../../utils/date/index';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils/commonUtils/validation-utils';
import { FULL_NAME } from '../../utils';
import { User } from '../../account/dtos';
import { GET_PROJECTED_MARGIN } from './get-projected-margin';

export const QUICK_SEARCH_TABLE = (
	projects: ProjectDTO[],
	usersList: Array<User> = []
): QuickSearchResult[] => {
	let results: Array<QuickSearchResult> = [];
	try {
		if (projects.length > 0) {
			projects.map((projectDTO: ProjectDTO) => {
				let project = {} as QuickSearchResult;
				project.id = projectDTO.id;
				project.name = projectDTO.name;
				project.laneName = GET_LANE_PATH_STRING(projectDTO);
				project.assigneeId = projectDTO.assigneeId;
				project.userId = projectDTO.userId;
				project.dueDate = DATE_MDY(projectDTO.dueDate);
				const user = usersList.find((user) => projectDTO.userId == user.id);
				if (IS_NOT_NULL_OR_UNDEFINED(user)) {
					project.ownerName = FULL_NAME(user.firstName, user.lastName);
				}
				let projectedMargin = GET_PROJECTED_MARGIN(projectDTO);
				if (IS_NOT_NULL_OR_UNDEFINED(projectedMargin)) {
					projectedMargin = Math.round(projectedMargin * 100);
					project.projectedMargin = `${projectedMargin} %`;
				}
				results.push(project);
			});
		}
	} catch (error) {
		console.log('QUICK_SEARCH_TABLE error: ', error);
	}

	return results;
};
